export type ApiErrorDetail = { path: string; message: string };

/** Erro de chamada à API, no formato único `{ error: { code, message, details } }`. */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details: ApiErrorDetail[] = [],
    public readonly requestId?: string,
    /** Segundos que o servidor pediu para esperar antes de repetir (cabeçalho Retry-After; sobrecarga, T-254). */
    public readonly retryAfterSeconds?: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  /** Sem resposta do servidor (offline, DNS, CORS, servidor fora do ar). */
  get isNetworkError(): boolean {
    return this.status === 0;
  }

  get isServerError(): boolean {
    return this.status >= 500;
  }

  /** Mensagem do campo, para mostrar ao lado do input. */
  fieldMessage(path: string): string | undefined {
    return this.details.find((d) => d.path === path)?.message;
  }
}

export const NETWORK_ERROR_MESSAGE =
  'Não foi possível conectar ao servidor. Verifique sua conexão com a internet e tente novamente.';

/** Mensagem amigável para qualquer erro capturado na interface. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof Error && err.message) return err.message;
  return 'Algo deu errado. Tente novamente.';
}
